const $6f019d1f45ba2738$var$initScrollReveal = (targetElements, defaultProps)=>{
    if (typeof ScrollReveal === 'undefined') {
        console.warn('ScrollReveal is not loaded');
        return;
    }
    const sr = ScrollReveal({
        origin: defaultProps.origin,
        distance: defaultProps.distance,
        duration: defaultProps.duration,
        delay: defaultProps.delay,
        rotate: defaultProps.rotate,
        opacity: defaultProps.opacity,
        scale: defaultProps.scale,
        easing: defaultProps.easing,
        mobile: defaultProps.mobile,
        reset: defaultProps.reset,
        useDelay: defaultProps.useDelay,
        viewFactor: defaultProps.viewFactor,
        viewOffset: defaultProps.viewOffset
    });
    targetElements.forEach((element)=>{
        sr.reveal(element, defaultProps);
    });
};
var $6f019d1f45ba2738$export$2e2bcd8739ae039 = $6f019d1f45ba2738$var$initScrollReveal;


const $b8855ed206bb3c2e$var$initTiltEffect = ()=>{
    if (typeof VanillaTilt === 'undefined') {
        console.warn('VanillaTilt is not loaded');
        return;
    }
    const tiltElements = document.querySelectorAll('.priority-card, .project-card');
    tiltElements.forEach((element)=>{
        VanillaTilt.init(element, {
            max: 15,
            speed: 400,
            glare: true,
            'max-glare': 0.2
        });
    });
};
var $b8855ed206bb3c2e$export$2e2bcd8739ae039 = $b8855ed206bb3c2e$var$initTiltEffect;


const $d859da13df4a30ff$export$adcf75ad64a03007 = [
    '.hero-section',
    '.about-section',
    '.priorities-section',
    '.priority-card',
    '.projects-section'
];
const $d859da13df4a30ff$export$9c21a3269931e1e6 = {
    origin: 'bottom',
    distance: '20px',
    duration: 1000,
    delay: 100,
    rotate: {
        x: 0,
        y: 0,
        z: 0
    },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.6, 0, 0.2, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor: 0.2,
    viewOffset: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    }
};


// Enhanced dropdown functionality for accessibility
document.addEventListener('DOMContentLoaded', function() {
    const dropdownToggles = document.querySelectorAll('.dropdown-toggle');
    dropdownToggles.forEach((toggle)=>{
        const dropdown = toggle.nextElementSibling;
        if (!dropdown) return;
        // Desktop: Show on hover
        if (window.innerWidth > 991) {
            toggle.addEventListener('mouseenter', function() {
                $(this).dropdown('show');
            });
            const dropdownMenu = $(dropdown);
            dropdownMenu.on('mouseenter', function() {
                $(toggle).dropdown('show');
            });
            dropdownMenu.on('mouseleave', function() {
                $(toggle).dropdown('hide');
            });
            toggle.addEventListener('mouseleave', function(e) {
                if (!dropdown.contains(e.relatedTarget)) $(this).dropdown('hide');
            });
        }
        // Keyboard navigation
        toggle.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                $(this).dropdown('toggle');
            } else if (e.key === 'Escape') {
                $(this).dropdown('hide');
                this.focus();
            }
        });
        // Handle dropdown item keyboard navigation
        const items = dropdown.querySelectorAll('.dropdown-item');
        items.forEach((item, index)=>{
            item.addEventListener('keydown', function(e) {
                if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    const next = items[index + 1] || items[0];
                    next.focus();
                } else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    const prev = items[index - 1] || items[items.length - 1];
                    prev.focus();
                } else if (e.key === 'Escape') {
                    $(toggle).dropdown('hide');
                    toggle.focus();
                }
            });
        });
    });
});


(0, $6f019d1f45ba2738$export$2e2bcd8739ae039)((0, $d859da13df4a30ff$export$adcf75ad64a03007), (0, $d859da13df4a30ff$export$9c21a3269931e1e6));
(0, $b8855ed206bb3c2e$export$2e2bcd8739ae039)();


//# sourceMappingURL=Campaign.b6279de9.js.map
